<template>
  <el-tabs value="tab1" type="card" @tab-click="changeTab">
    <el-tab-pane label="测试台产品" name="tab1">
      <material-standard-mapping-list ref="tabBox"/>
    </el-tab-pane>
    <el-tab-pane label="测试台产品记录" name="tab2">
      <material-standard-mapping-log-list ref="tabBoxLog"/>
    </el-tab-pane>
    <el-tab-pane label="COP程序维护" name="tab3">
      <cop-material-list ref="tabCop"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import MaterialStandardMappingList from "@/views/information/MaterialStandardMapping/MaterialStandardMappingList.vue";
  import MaterialStandardMappingLogList
    from "@/views/information/MaterialStandardMapping/MaterialStandardMappingLogList.vue";
  import CopMaterialList from "@/views/information/MaterialStandardMapping/CopMaterialList.vue";

  export default {
    name: "MaterialStandardMappingTabs",
    components: {MaterialStandardMappingList, MaterialStandardMappingLogList, CopMaterialList},
    methods: {
      changeTab(name) {
        if (name == "tab1") {
          this.$refs.tabBox.getList(1);
        } else if (name == "tab2") {
          this.$refs.tabBoxLog.getList(1);
        } else if (name == "tab3") {
          this.$refs.tabCop.getList(1);
        }
      },
    },
  };
</script>

<style scoped lang="scss">

</style>